import React from 'react';
import { Button, Col, Popconfirm } from 'antd';

const DeleteProfileSection = ({ deleteProfileAccount, deleteProfileStage, form }) => {
  let deleteProfileSection = (
    <Col xs={24}>
      <Button
        className="btn-danger delete-account-buttons"
        onClick={() => deleteProfileAccount('next')}
      >
        Delete Account
      </Button>
    </Col>
  );

  if (deleteProfileStage === 'first') {
    deleteProfileSection = (
      <React.Fragment>
        <Col xs={24}>
          {form.slice(4,6)}
        </Col>
        <Col xs={24}>
          <Button
            className="btn-danger delete-account-buttons"
            onClick={() => deleteProfileAccount('next')}
          >
            Delete Account
          </Button>
          <Button
            className="btn-logout delete-account-buttons"
            onClick={() => deleteProfileAccount('cancel')}
          >
            Cancel
          </Button>
        </Col>
      </React.Fragment>
    );
  }
  if (deleteProfileStage === 'second') {
    deleteProfileSection = (
      <React.Fragment>
        <Col xs={24}>
          You can delete your profile. Please confirm your acton.
        </Col>
        <Col xs={24}>
          <Button className="btn-danger delete-account-buttons">
            <Popconfirm
              title={`Do you really want to delete this account?`}
              onConfirm={() => deleteProfileAccount('complete')}
              okText="Yes"
              cancelText="No"
            >
              <a href="#">Delete Account</a>
            </Popconfirm>
          </Button>
          <Button
            className="btn-logout delete-account-buttons"
            onClick={() => deleteProfileAccount('cancel')}
          >
            Cancel
          </Button>
        </Col>
      </React.Fragment>
    );
  }

  return deleteProfileSection;
}

export default DeleteProfileSection;


// WEBPACK FOOTER //
// ./src/pages/MyProfile/InfoAndEventsTab/DeleteProfileSection/index.js